import PanelPage from 'navigation/pages/PanelPage';
import { bindMethod } from 'helpers/bind';
import store from 'store';
import { forceArray } from 'navigation/component/Component';
import SizeGuideTable from './partials/SizeGuideTable';
export default class SizeGuide extends PanelPage {
    getModulesMap() {
        return {
            sizeGuideTable: ['.sizes__item-content', SizeGuideTable]
        };
    }
    initialized() {
        super.initialized();
        forceArray(this.refs.toggleUnits).forEach(el => {
            if (el.getAttribute('data-unit') === 'cm')
                el.classList.add('active');
        });
    }
    bindEvents(add) {
        super.bindEvents(add);
        const method = bindMethod(add);
        this.refs.previousButton[method]('click', this.onPreviousButtonClick);
        this.refs.toggleUnits?.forEach((el) => {
            el[method]('click', this.toggleUnits);
        });
    }
    toggleUnits = (e) => {
        const button = e.currentTarget;
        const unit = button?.getAttribute('data-unit');
        this.refs.toggleUnits?.forEach((el) => {
            el.classList.toggle('active', el.dataset.unit === unit);
        });
        this.el.setAttribute('data-unit', unit);
        forceArray(this.modules.sizeGuideTable).forEach((table) => {
            table.resize();
        });
    };
    onPreviousButtonClick = () => {
        const page = document.querySelector('.page.product');
        page?.dispatchEvent?.(new CustomEvent('show-size'));
        store.panel.set(null);
    };
    resize() {
        this.refs.sizesInner.style.height = `calc(var(--vh) - ${this.refs.sizesHeader.clientHeight}px)`;
        super.resize();
    }
}
